import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { Branch } from '@app/models/branch';
import { SavingAgreementApproval } from '@app/models/saving-agreement-approval';
import { Constants } from "@app/constants/constants";

@Component({
    selector: 'app-saving-agreement-summary',
    templateUrl: './saving-agreement-summary.component.html',
    styleUrls: ['./saving-agreement-summary.component.css'],
    standalone: false
})
export class SavingAgreementSummaryComponent implements OnInit, OnChanges {

  @Input() savingAgreementApproval: SavingAgreementApproval;
  @Input() isSavingApproval: boolean;

  @Input() branches: Array<Branch>;

  interestCalculationOptions = Constants.INTEREST_CALCULATION_OPTIONS;

  ngOnInit(): void {
    if (!this.savingAgreementApproval) {
      this.savingAgreementApproval = new SavingAgreementApproval();
    }
  }

  ngOnChanges() {
  }


  formatNumber(value) {
    if (value === null || value === undefined || isNaN(value)) return '';
    return MethodsHelper.numberWithCommas(value);
  }

  getFormatDate(yyyymmdd) {
    if (yyyymmdd) {
      let items = yyyymmdd.split("-");
      if (items.length == 3) {
        return items[2] + "." + items[1] + "." + items[0].substr(2);
      }
    }
    return "";
  }

  findSymbol() {
    if (this.savingAgreementApproval && this.savingAgreementApproval.currency) {
      return MethodsHelper.findSymbol(this.savingAgreementApproval.currency);
    }
    return "";
  }

  formatGracePeriod(value) {
    if (value) {
      let graceNumber = value.substring(1, value.length - 1);
      if (value[length - 1] == 'D') {
        return graceNumber + " days";
      } else if (value[length - 1] == 'Y') {
        return graceNumber + " years";
      }
      return graceNumber + " months";
    }
    return "";
  }

  findInterestCalculationOptions(type) {
    let itemType = this.interestCalculationOptions.find(p => p.value == type);
    if (itemType) {
      return itemType.label;
    }
    return "";
  }

  loanPeriodGenType(type) {
    let typePeriod = '';
    switch (type) {
      case "M": typePeriod = "months";
        break;
      case "Y": typePeriod = "years";
        break;
      case "W": typePeriod = "weeks";
        break;
      case "D": typePeriod = 'days';
        break;
      default: typePeriod = 'unknown'
    }
    return typePeriod;
  }

  getBranchName(branchId) {
    if (this.branches) {
      let item = this.branches.find(p => p.id == branchId);
      if (item) {
        return item.name;
      }
    }
    return "";
  }

  getBranchNameFromCode(branchCode) {
    if (this.branches) {
      let item = this.branches.find(p => p.code == branchCode);
      if (item) {
        return item.name;
      }
    }
    return "";
  }

  formatTextCapitalize(str: string) {
    if (str.indexOf('_') !== -1) {
      str = str.split('_').join(' ');
    }
    return MethodsHelper.textCapitalize(str);
  }
}
